import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#0073FF", // TT blauw
        secondary: colors.cyan.lighten4, // TT paars
        success: colors.green.lighten1, // #66bb6a
        info: colors.lightBlue.lighten1, // #29b6f6
        warning: colors.orange, // #ff9800
        error: colors.red.lighten1, // #ef5350
      },
    },
  },
  icons: {
    iconfont: "md",
  },
  defaultAssets: {
    font: {
      family: "Poppins",
    },
  },
});
